export default __webpack_public_path__ + "static/media/certifi_12new.54e1af62.png";